import React from "react";

function projectCard({ image, backColor, front, title, link }) {
  return (
    <div class="card">
      <div class="card__side card__side--front">
        <div class={`card__picture ${image}`}>&nbsp;</div>

        <div class="card__details">
          <ul>
            {front.map((e) => (
              <li>{e}</li>
            ))}
          </ul>
        </div>
      </div>
      <div class={`card__side card__side--back ${backColor} `}>
        <div class="card__cta">
          <div class="card__price-box">
            {/* <p class="card__price-only">Only</p> */}
            <p class="card__price-value">{title}</p>
          </div>
          <a href={link} target="_blank" rel="noreferrer" class="btn btn--white">
            Visit
          </a>
        </div>
      </div>
    </div>
  );
}

export default projectCard;
